import MobileNavigation from './navigation/MobileNavigation';
import StickyNavigation from './navigation/StickyNavigation';
import LoginNavigation from './navigation/LoginNavigation';
import LanguageSelector from './language-selector/LanguageSelector';

new StickyNavigation();
new MobileNavigation();
new LanguageSelector();

const loadDynamicConf = (loadedCallback: () => void) => {
	const origin: string = document.location.origin.replace('localhost', 'integ-config');
	const scriptTag: HTMLScriptElement = document.createElement('script');
	scriptTag.src = `${origin}/common/dynamicconf`;
	scriptTag.addEventListener('load', loadedCallback);
	scriptTag.addEventListener('error', loadedCallback);

	document.body.appendChild(scriptTag);
};

const checkDynamicConf = () => {
	if (!window.dynamicConf) {
		loadDynamicConf(initLoginForm);
	} else {
		initLoginForm();
	}
};

const initLoginForm = () => {
	new LoginNavigation();
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	checkDynamicConf();
} else {
	document.addEventListener('DOMContentLoaded', () => checkDynamicConf());
}
